"use client"

import type { ComponentProps } from "react"
import clsx from "clsx"

import type { Nullish } from "~/@types/generics"
import type { TDiptychLockupV2 } from "~/lib/storyblok/schemas/library/components/diptych_text_image_lockup_v2"
import InlineCta from "~/components/ui/InlineCta"
import type { TLinkLabel } from "~/components/ui/Link/_data/serializer"
import RichText from "~/components/ui/RichText"

import * as css from "./styles.css"

export default function DiptychLockupV2(item: TDiptychLockupV2 & { globalLink?: Nullish<TLinkLabel> }) {
  const { title, description, links, globalLink } = item
  if (!title && !description && links.length === 0) return null

  const ctasProps: ComponentProps<typeof InlineCta> = {
    className: clsx(css.link),
    withLine: true,
    withDefaultLine: true,
    color: "black",
  }

  return (
    <div className={css.wrapper}>
      <div className={css.content}>
        {title && <RichText className={clsx(css.title)} render={title} disableStyles />}
        {description && <RichText className={clsx(css.description)} render={description} disableStyles />}
      </div>
      {globalLink && <InlineCta {...globalLink} {...ctasProps} obfuscate />}
      {links &&
        !globalLink &&
        links.map((item, index) => {
          return <InlineCta key={`link_${index}`} {...item} {...ctasProps} />
        })}
    </div>
  )
}
